// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("../../../shared/src/types/TypeUtils.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var GraphQL_PPX = require("@reasonml-community/graphql-ppx/bucklescript/GraphQL_PPX.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_Email = require("../../../shared/src/types/CommonTypes_Email.bs.js");
var CommonTypes_User_Name = require("../../../shared/src/types/CommonTypes_User_Name.bs.js");
var CommonTypes_PhoneNumber = require("../../../shared/src/types/CommonTypes_PhoneNumber.bs.js");

var include = TypeUtils.MakeOpaqueIntType({});

var fromInt = include.fromInt;

var toInt = include.toInt;

var compare = include.compare;

var eq = include.eq;

function parse(param) {
  return Relude_Globals.$great$great(fromInt, Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: toInt
};

var Id_fromString = include.fromString;

var Id_toString = include.toString;

var Id_decode = include.decode;

var Id_encode = include.encode;

var Id_Ord = include.Ord;

var Id_Set = include.$$Set;

var Id_Map = include.$$Map;

var Id = {
  fromInt: fromInt,
  fromString: Id_fromString,
  toInt: toInt,
  toString: Id_toString,
  decode: Id_decode,
  encode: Id_encode,
  compare: compare,
  eq: eq,
  Ord: Id_Ord,
  $$Set: Id_Set,
  $$Map: Id_Map,
  GraphQL_API: GraphQL_API
};

var Raw = {};

var query = "fragment WebTypes_BusinessAdmin on User   {\n...CommonTypes_User_Name   \nemail  \nid  \nphoneNumber  \n}\n" + CommonTypes_User_Name.query;

function parse$1(value) {
  var value$1 = value["email"];
  var param = value["id"];
  return {
          commonTypes_User_Name: CommonTypes_User_Name.verifyArgsAndParse("CommonTypes_User_Name", value),
          email: !(value$1 == null) ? Caml_option.some(CommonTypes_Email.GraphQL_API_FromString.parse(value$1)) : undefined,
          id: Relude_Globals.$great$great(fromInt, Relude_Option.getOrThrow, param),
          phoneNumber: CommonTypes_PhoneNumber.GraphQL_API_FromString.parse(value["phoneNumber"])
        };
}

function serialize(value) {
  var value$1 = value.phoneNumber;
  var value$2 = CommonTypes_PhoneNumber.GraphQL_API_FromString.serialize(value$1);
  var value$3 = value.id;
  var value$4 = Curry._1(toInt, value$3);
  var value$5 = value.email;
  var email = value$5 !== undefined ? Curry._1(CommonTypes_Email.GraphQL_API_FromString.serialize, Caml_option.valFromOption(value$5)) : null;
  return [CommonTypes_User_Name.serialize(value.commonTypes_User_Name)].reduce(GraphQL_PPX.deepMerge, {
              email: email,
              id: value$4,
              phoneNumber: value$2
            });
}

function verifyArgsAndParse(_WebTypes_BusinessAdmin, value) {
  return parse$1(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  var email = param.email;
  if (email !== undefined) {
    return Relude_Option.pure({
                email: Caml_option.valFromOption(email),
                id: param.id,
                name: param.commonTypes_User_Name,
                phoneNumber: param.phoneNumber
              });
  }
  
}

function make(email, firstName, id, lastName, phoneNumber) {
  return {
          email: email,
          id: id,
          name: CommonTypes_User_Name.make(firstName, lastName),
          phoneNumber: phoneNumber
        };
}

function compare$1(param, param$1) {
  return Curry._2(compare, param.id, param$1.id);
}

function eq$1(param, param$1) {
  return Curry._2(eq, param.id, param$1.id);
}

var $$Set = Relude_Set.WithOrd({
      eq: eq$1,
      compare: compare$1
    });

function make$1(firstName, lastName, phoneNumber, email) {
  return {
          email: email,
          firstName: firstName,
          lastName: lastName,
          phoneNumber: phoneNumber
        };
}

function makeFromExisting(param) {
  var match = param.name;
  return make$1(match.firstName, match.lastName, param.phoneNumber, param.email);
}

var New = {
  make: make$1,
  makeFromExisting: makeFromExisting
};

exports.Id = Id;
exports.Raw = Raw;
exports.query = query;
exports.parse = parse$1;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
exports.make = make;
exports.$$Set = $$Set;
exports.New = New;
/* include Not a pure module */
